import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutTop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconLayoutTop"><Path d="M6.75 20.25C5.09315 20.25 3.75 18.9069 3.75 17.25L3.75 10.75C3.75 9.09315 5.09315 7.75 6.75 7.75L17.25 7.75C18.9069 7.75 20.25 9.09315 20.25 10.75V17.25C20.25 18.9069 18.9069 20.25 17.25 20.25L6.75 20.25Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M3.75 3.75H20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconLayoutTop;
